
/* styles */
require("!!../../../../node_modules/.2.1.0@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/.11.3.4@vue-loader/lib/style-compiler/index?{\"id\":\"data-v-48b788b6\",\"scoped\":true,\"hasInlineConfig\":false}!stylus-loader?{\"sourceMap\":true}!../../../../node_modules/.11.3.4@vue-loader/lib/selector?type=styles&index=0!./Setting.vue")

var Component = require("!../../../../node_modules/.11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/.11.3.4@vue-loader/lib/selector?type=script&index=0!./Setting.vue"),
  /* template */
  require("!!../../../../node_modules/.11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-48b788b6\"}!../../../../node_modules/.11.3.4@vue-loader/lib/selector?type=template&index=0!./Setting.vue"),
  /* scopeId */
  "data-v-48b788b6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/nav/server/Setting.vue
// module id = 154
// module chunks = 1